import { ComponentProps } from 'react';

import { ExpandLess, ExpandMore } from '@mui/icons-material';

/**
 * @param {{mode: 'opened' | 'closed' | 'up' | 'down' }}
 */
export const ChevronByParameter: React.FC<
  ComponentProps<typeof ExpandLess> & {
    mode: 'closed' | 'opened' | 'up' | 'down';
  }
> = ({ mode, ...props }) => {
  const Component =
    mode === 'closed' || mode === 'down' ? ExpandMore : ExpandLess;
  return <Component {...props} />;
};
